import { render } from "./ReleaseMusic.vue?vue&type=template&id=3fbe519e&scoped=true&ts=true"
import script from "./ReleaseMusic.vue?vue&type=script&lang=ts"
export * from "./ReleaseMusic.vue?vue&type=script&lang=ts"

import "./ReleaseMusic.vue?vue&type=style&index=0&id=3fbe519e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbe519e"]])

export default __exports__